const getNewSeriesId = (id = 'welcome_bot_nft_series_0') => {
    id = id || 'welcome_bot_nft_series_1'

    return `${id.substring(0, id?.lastIndexOf('_'))}_${Number(id?.substring(id?.lastIndexOf('_') + 1)) + 1}`;
}
export { getNewSeriesId };